import { Fragment, lazy, Suspense } from 'react';

import ChartDonut from '@/container/ChartDonut';

import ChartTable from '@/container/ChartTable';
import PivotTableV1 from '@/container/PivotTableV1';
import PivotTableDynamic from '@/container/PivotTableDynamic';
import ChartGroupedBar from '@/container/ChartGroupedBar';
import ChartBarHorizontal from '@/container/ChartBarHorizontal';
import ChartStackedHoriBar from '@/container/ChartStackedHoriBar';
import ChartColumnGrouped from '@/container/ChartColumnGrouped';
import ChartBar from '@/container/ChartBar';
import ChartStackedBar from '@/container/ChartStackedColumnBar';

import { BasicCard } from '@/components/uiPart';
import PageLoader from '@/components/PageLoader';

// import PivotTable from '@/container/PivotTable';


const ChartDrawer = (props: any) => {

  // const TAG: string = "ChartDrawer: ";
  const { graphData } = props;

  const PivotTable = lazy(() => import('@/container/PivotTable').then(module => ({ default: module.default })));

  return (
    <div className="grid grid-cols-2 mt-4 gap-4">
      {graphData?.map((item: any, index: number) => (
        <Fragment key={`${item?.title}-${index}`}>

          {item?.type === 'pivot_chart' && (
            <BasicCard
              // title={item?.title || ''}
              className="w-full flex flex-col text-center !p-4"
              // titleCls="!text-[14px] !font-semibold !text-center w-full "
              key={`${item?.title}-${index}`}
            >
              <Suspense fallback={<PageLoader message="Loading..." />}>
                <PivotTable item={item} expandDefault={true} />
              </Suspense>
            </BasicCard>
          )}

          {item?.type === '2d_pivot_chart' && (
            <BasicCard
              title={item?.title || ''}
              className="w-full flex flex-col !p-4"
              titleCls="!text-[14px] !font-semibold !text-center w-full "
              key={`${item?.title}-${index}`}
            >
              <PivotTableV1 item={item} />
            </BasicCard>
          )}

          {item?.type === 'pivot_chart_dynamic' && (
            <BasicCard
              title={item?.title || ''}
              className="w-full flex flex-col !p-4"
              titleCls="!text-[14px] !font-semibold !text-center w-full "
              key={`${item?.title}-${index}`}
            >
              <PivotTableDynamic items={item?.data?.[0] ? item : []} />
            </BasicCard>
          )}


          {item?.type === 'table' && (
            <BasicCard
              // title={item?.title || ''}
              className="w-full flex flex-col !p-4 "
              // titleCls="base-card-title !font-semibold !text-center w-full "
              key={`${item?.title}-${index}`}
            >
              <ChartTable tableData={[item]} />
            </BasicCard>
          )}









          {item?.type === 'grouped_bar_chart' && (
            <>
              {item?.data && item?.data?.length > 0 &&
                <BasicCard
                  // title={item?.title || ''}
                  className="w-full flex flex-col !p-4 overflow-auto "
                  // titleCls="text-lg !text-center w-full "
                  titleCls="!text-[14px] !font-semibold !text-center w-full "
                  key={`${item?.title}-${index}`}
                >
                  <ChartGroupedBar item={item} />
                </BasicCard>
              }

              {/* {!item?.data || item?.data?.length == 0 && */}
              {(item?.data == null || item?.data?.length == 0) &&
                <BasicCard>
                  <div className='text-center text-[11px] text-[#000000] font-bold  '> {item?.title} </div>
                </BasicCard>
              }

            </>
          )}


          {item?.type === 'stacked_horizontal_bar_chart' && (
            <>

              {item?.data && item?.data?.length > 0 &&
                <BasicCard
                  // title={item?.title || ''}
                  className="w-full flex flex-col !p-4 overflow-auto h-max  "
                  titleCls="!text-[14px] !font-semibold !text-center w-full "
                  key={`${item?.title}-${index}`}
                >
                  <ChartStackedHoriBar item={item} />
                </BasicCard>
              }

              {(item?.data == null || item?.data?.length == 0) &&
                <BasicCard>
                  <div className='text-center text-[11px] text-[#000000] font-bold  '> {item?.title} </div>
                </BasicCard>
              }

            </>

          )}

          {item?.type === 'pie' && (
            <BasicCard
              // title={item?.title || ''}
              className="w-full flex flex-col overflow-x-auto h-max !p-4 "
              titleCls="base-card-title !font-semibold !text-center w-full "
              key={`${item?.title}-${index}`}
            >
              <ChartDonut chartData={item} />
            </BasicCard>
          )}

          {item?.type === 'horizontal_bar_chart' && (
            <>

              {item?.data && item?.data?.length > 0 &&
                <BasicCard
                  // title={item?.title || ''}
                  className="w-full flex flex-col !p-4 overflow-auto h-max  "
                  titleCls="!text-[14px] !font-semibold !text-center w-full "
                  key={`${item?.title}-${index}`}
                >
                  <ChartBarHorizontal item={item} />
                </BasicCard>
              }

              {(item?.data == null || item?.data?.length == 0) &&
                <BasicCard>
                  <div className='text-center text-[11px] text-[#000000] font-bold  '> {item?.title} </div>
                </BasicCard>
              }
            </>

          )}


          {item?.type === 'bar_chart' && (
            <BasicCard
              // title={item?.title || ''}
              className="w-full flex flex-col !p-4 overflow-auto "
              titleCls="!text-[14px] !font-semibold !text-center w-full "
              key={`${item?.title}-${index}`}
            >
              <ChartBar item={item} />
            </BasicCard>
          )}

          {item?.type === 'stacked_column_chart' && (

            <>
              {item?.data && item?.data?.length > 0 &&
                <BasicCard
                  // title={item?.title || ''}
                  className="w-full flex flex-col !p-4 overflow-auto h-max  "
                  // titleCls="text-lg !text-center w-full "
                  titleCls="!text-[14px] !font-semibold !text-center w-full "
                  key={`${item?.title}-${index}`}
                >
                  <ChartStackedBar item={item} />
                </BasicCard>
              }

              {(item?.data == null || item?.data?.length == 0) &&
                <BasicCard>
                  <div className='text-center text-[11px] text-[#000000] font-bold  '> {item?.title} </div>
                </BasicCard>
              }

            </>
          )}

          {item?.type === 'grouped_column_chart' && (
            <>
              {item?.data && item?.data?.length > 0 &&
                <BasicCard
                  // title={item?.title || ''}
                  className="w-full flex flex-col !p-4 overflow-auto h-max  "
                  titleCls="!text-[14px] !font-semibold !text-center w-full "
                  key={`${item?.title}-${index}`}
                >
                  <ChartColumnGrouped item={item} />
                </BasicCard>
              }
              {(item?.data == null || item?.data?.length == 0) &&
                <BasicCard>
                  <div className='text-center text-[11px] text-[#000000] font-bold  '> {item?.title} </div>
                </BasicCard>
              }
            </>
          )}


        </Fragment>
      ))}
    </div>
  );
};

export default ChartDrawer; 